import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import Home from './Home';
import MasinaDetalii from './MasinaDetalii';
import Admin from './Admin';
import Contact from './Contact';
import Garantie from './Garantie';
import Livrare from './Livrare';
import Confidentialitate from './Confidentialitate';
import Termeni from './Termeni';
import './App.css';

function AppContent() {
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 992);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const showNav = !location.pathname.startsWith('/admin');
    // These pages end in a dark section; dock the mobile nav tightly under
    // it on a seamless navy-deep backdrop (a third button under the CTAs on
    // Garanție/Livrare; snug under the map/info panel on Contact).
    const dockTight = location.pathname === '/garantie'
        || location.pathname === '/livrare'
        || location.pathname === '/contact';

    return (
        <>
            <ScrollToTop />

            {/* Navbar sits after Routes inside this wrapper so the mobile
                sticky pill can dock between page content and the footer.
                Desktop navbar is fixed-top, unaffected by DOM position.
                The background shows only in the dock gap (pages paint
                their own backgrounds): navy to blend into the footer,
                except Home where it matches the light page background. */}
            <div className={dockTight ? 'nav-dock-tight' : undefined} style={{ background: location.pathname === '/' ? '#f8f9fa' : 'var(--trust-navy-deep)' }}>
                <Routes>

                    <Route path="/" element={<Home />} />
                    <Route path="/masina/:slug" element={<MasinaDetalii />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/garantie" element={<Garantie />} />
                    <Route path="/livrare" element={<Livrare />} />
                    <Route path="/confidentialitate" element={<Confidentialitate />} />
                    <Route path="/termeni" element={<Termeni />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="*" element={
                        <div style={{ minHeight: '100vh', background: '#f0f4f9', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '120px' }}>
                            <div className="text-center">
                                <h1 style={{ fontSize: '4rem', fontWeight: '800', color: '#1c2e4a' }}>404</h1>
                                <p style={{ color: '#6b7280', marginBottom: '24px' }}>Pagina nu a fost găsită</p>
                                <a href="/" style={{ color: '#ff8e18', fontWeight: '600', textDecoration: 'none' }}>Înapoi la Showroom</a>
                            </div>
                        </div>
                    } />
                </Routes>
                {showNav && <Navbar />}
            </div>
            {showNav && <Footer isMobile={isMobile} />}
        </>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;
